export function readStoredTab(storageKey: string, fallback: string, allowedTabs: string[]): string {
  if (typeof window === "undefined") return fallback;
  const stored = window.localStorage.getItem(storageKey);
  return stored && allowedTabs.includes(stored) ? stored : fallback;
}
